import { createContext, useReducer, useMemo } from "react";
import { toast } from "react-toastify";
import { axiosPrivate } from "../../api/axios";
import TokenService from "../../api/token.service";
import AuthReducer from "./AuthReducer";

const AuthContext = createContext({});

const intialAuthState = {
  auth: TokenService.getUser() || {},
  isLoading: false,
  isError: false,
  isUserError: false,
  userDetails: JSON.parse(localStorage.getItem("userDetail")) || {},
  applicationIds: [],
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, intialAuthState);

  const loginUser = async (params) => {
    dispatch({ type: "LOGIN_START" });
    try {
      const response = await axiosPrivate.post("/auth/login", JSON.stringify(params), {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      const { data } = response;
      if (data.success && data.message === "Login Successfull") {
        const accessToken = data.data.token;
        TokenService.setUser(accessToken);
        dispatch({ type: "LOGIN_SUCCESS", payload: accessToken });
      } else if (data.success && data.message === "MFA Options") {
        dispatch({ type: "LOGIN_RESET" });
        return data;
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
        dispatch({ type: "LOGIN_ERROR" });
      }
      return data;
    } catch (error) {
      dispatch({ type: "LOGIN_ERROR" });
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
    }
  };

  const getUserDetails = async () => {
    dispatch({ type: "GET_LOGGED_USER_DETAILS" });
    try {
      const response = await axiosPrivate.get("/user/profile");
      const { data } = response;
      localStorage.setItem("userDetail", JSON.stringify(data.data));
      dispatch({ type: "GET_LOGGED_USER_DETAILS_SUCCESS", payload: data.data });
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "GET_LOGGED_USER_DETAILS_FAILED" });
    }
  };

  const generateOpt = async (params) => {
    try {
      const response = await axiosPrivate.post("/auth/generate-otp", params);
      const { data } = response;
      if (data.success) {
        toast.success(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      }
      return data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };
  const generateSessionID = async (params) => {
    dispatch({ type: "LOGIN_START" });
    try {
      const response = await axiosPrivate.post("auth/generate-session", params,{
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      const { data } = response;
      if (data.success) {
        dispatch({ type: "LOGIN_START" });
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      }
      return data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };

  const verifyUserOtp = async (params) => {
    try {
      const response = await axiosPrivate.post("/auth/submit-otp", params);
      const { data } = response;
      if (data.success) {
        toast.success(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      }
      return response;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };

  const updateMfaAuthentication = async (params) => {
    dispatch({ type: "LOGIN_START" });
    try {
      const response = await axiosPrivate.post("/user/mfa-authentication", params);
      const { data } = response;
      if (data.success) {
        toast.success(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 1000, theme: "colored" });
      }
      dispatch({ type: "LOGIN_RESET" });
      getUserDetails();
      return response;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };

  const emailToResetPassword = async (params) => {
    dispatch({ type: "LOGIN_START" });
    try {
      const response = await axiosPrivate.post("/auth/forgot-password", params);
      const { data } = response;
      if (data.success) {
        toast.success(data.message, { position: "bottom-right", autoClose: 3000, theme: "colored" });
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 3000, theme: "colored" });
      }
      dispatch({ type: "LOGIN_RESET" });
      return response;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };

  const updatePassword = async (params) => {
    dispatch({ type: "LOGIN_START" });
    try {
      const response = await axiosPrivate.post("/auth/reset-password", params);
      const { data } = response;
      if (data.success) {
        toast.success(data.message, { position: "bottom-right", autoClose: 3000, theme: "colored" });
      } else {
        toast.error(data.message, { position: "bottom-right", autoClose: 3000, theme: "colored" });
      }
      dispatch({ type: "LOGIN_RESET" });
      return response;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };

  const getApplicationIds = async () => {
    dispatch({ type: "LOGIN_START" });
    try {
      const response = await axiosPrivate.get("/access/applications");
      const { data } = response;
      if(data.data.length==1){
      window.location.replace (data.data[0].url+"&isSingleApp=true");
    }
    else{
      dispatch({ type: "GET_APPLICATION_DETAILS", payload: data.data || [] });
    }
      
      return response;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      toast.error(message, { position: "bottom-right", autoClose: 2000, theme: "colored" });
      dispatch({ type: "LOGIN_ERROR" });
    }
  };

  const value = useMemo(() => ({
    getUserDetails,
    loginUser,
    isLoading: state.isLoading,
    auth: state.auth,
    isError: state.isError,
    isUserError: state.isUserError,
    userDetails: state.userDetails,
    applicationIds: state.applicationIds,
    dispatch,
    generateOpt,
    generateSessionID,
    verifyUserOtp,
    updateMfaAuthentication,
    emailToResetPassword,
    updatePassword,
    getApplicationIds,
  }), [getUserDetails,
    loginUser,
    state.isLoading,
    state.auth,
    state.isError,
    state.isUserError,
    state.userDetails,
    state.applicationIds,
    dispatch,
    generateOpt,
    generateSessionID,
    verifyUserOtp,
    updateMfaAuthentication,
    emailToResetPassword,
    updatePassword,
    getApplicationIds,
  ]);
  
  return (
    <AuthContext.Provider
      value={value} >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;